import React from "react";
import { Button, Box } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { Modal, Form, TextInput } from "components";
import { casesActions } from "configs";
import { useCurrentCase, useParams } from "duck";
import { useUpdatePatientPhysicalExamMutation } from "requests";

interface CommentProps {
  fieldName: string;
  isOpen: boolean;
  onClose(): void;
}

const Comment: React.FC<CommentProps> = ({ fieldName, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdatePatientPhysicalExamMutation();
  const { examId, shouldSync } = useCurrentCase(medicalCase => ({
    examId: medicalCase.data.client.patient.physicalExam._id,
    shouldSync: medicalCase.shouldSync
  }));

  return (
    <Modal
      title="Additional comments and notes"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Form
        onSubmit={values => {
          dispatch(
            casesActions.updatePhysicalExam({ _id: caseId, data: values })
          );
          if (shouldSync) {
            return update({
              variables: { input: { _id: examId, ...values } }
            }).then(() => {
              onClose();
            });
          }
          onClose();
        }}
      >
        <Box py={6}>
          <TextInput
            autoFocus
            type="text-area"
            name={`${fieldName}AbnormalStateComments`}
            label="Additional comments and notes"
            placeholder="Additional comments and notes"
          />
        </Box>
        <Form.Controls submitText="Save">
          <Button variant="outline" colorScheme="gray" onClick={onClose}>
            Cancel
          </Button>
        </Form.Controls>
      </Form>
    </Modal>
  );
};

export default Comment;
